import classNames from "classnames";
import useGlobalParams from "../../hooks/useGlobalParams";
import useOrganizations from "../../hooks/useOrganizations";

import SettingsNavigation from "./SettingsNavigation";
import Button from "../../common/Button/Button";
import Form from 'react-bootstrap/Form';
import { Trans as T } from 'react-i18next';

import { ReactComponent as CheckMarkIcon } from "../../assets/icons_svg/check-mark-outline-thin.svg";
import { ReactComponent as ErrorIcon } from "../../assets/icons_svg/error-thick.svg";
import { ReactComponent as VisaIcon } from "../../assets/icons_svg/visa.svg";

import './Billing.scss';
import { useNavigate } from "react-router-dom";

const SUMMARY_SECTIONS = {
  lead_count     : "Leads",
  user_count     : "Users",
  business_count : "Businesses",
}

const BILLS = [
  {
    invoice_id: '0003-S',
    plan_type: "Solo Plan",
    price: 9,
    status: "pending",
    date: "July 2, 2026"
  },
  {
    invoice_id: '0002-S',
    plan_type: "Solo Plan",
    price: 9,
    status: "paid",
    date: "June 2, 2026"
  },
  {
    invoice_id: '0001-B',
    plan_type: "Basic Plan",
    price: 29,
    status: "paid",
    date: "May 2, 2026"
  }
];

const formatter = new Intl.NumberFormat('en', { notation: "compact" });

export default function Billing() {

  const { organizationId } = useGlobalParams();
  const { data: organizations } = useOrganizations();
  const navigate = useNavigate();

  if (!organizations) {
    return;
  }

  const organization = organizations.find(org => org.id === organizationId);

  const MAX_COUNT = {
    lead_count     : 100000,
    user_count     : 10,
    business_count : 1,
  }

  const changeOrganization = e => {
    const id = e.target.value;
    navigate({ pathname: '/billing', search: `organization_id=${id}` });
  }

  return (
    <>
      <SettingsNavigation />
      <div className="__billing">
        <div className="details-org">
          <h2>Plan Details</h2>

          <div className="switch-org">
            <div className="switch-label"><T>Switch Organization</T></div>
            <Form.Select value={organizationId} onChange={changeOrganization}>
              { organizations?.map(organization => (
                <option key={organization.id} disabled={organization.id === organizationId} value={organization.id}>{ organization.name }</option>
              ))}
            </Form.Select>
          </div>
        </div>
        <div className="plan-payment">
          <div className="current-plan">
            <div className="plan-content">
              <div className="plan-description">
                <div className="plan-type">PRO</div>
                <ul className="features">
                  <li><CheckMarkIcon /><span>1 business</span></li>
                  <li><CheckMarkIcon /><span>10 users</span></li>
                  <li><CheckMarkIcon /><span>100,000 leads</span></li>
                </ul>
              </div>
              <div className="plan-price-cadence">
                <div className="plan-price">$9</div>
                <div className="cadence">per month</div>
              </div>
            </div>
            <div className="change-plan">
              <Button variant='primary'>Upgrade Plan →</Button>
              <div className="yearly-switch">
                <Button variant='link'>Switch to yearly</Button>
                <div className="off">20% off</div>
              </div>
            </div>
          </div>
          <div className="payment-method">
            <h3>Payment Method</h3>
            <div className="card-info">
              <div className="card-logo"><VisaIcon /></div>
              <div>
                <div className="card-details">Visa ending in 4312</div>
                <div className="expiration">expires 03/27</div>
              </div>
            </div>
            <Button className='update-method' variant='link'>Update payment method</Button>
            <div className="next-billing">Next billing: <strong>October 23rd 2025</strong></div>
          </div>
        </div>

        <h2>Usage Summary</h2>
        <div className="usage-summary">
          { Object.entries(SUMMARY_SECTIONS).map(([key, value]) => (
            <div key={key} className={classNames("usage-box", {[`box-${key}`]: key })}>
              <div className="field">{ value }</div>
              <div className="total-count">{ formatter.format(organization[key]) } / { formatter.format(MAX_COUNT[key]) }</div>
              <div className="percentage-bar">
                <div className="total-percentage" style={{ width: `${Math.min(100, Math.max(2, organization[key] / MAX_COUNT[key] * 100))}%`}} />
              </div>
            </div>
          ))}
        </div>

        <div className="billing-pricing">
          <h2>Billing History</h2>
          <div className="pricing-currency">All prices in US dollars</div>
        </div>

        <div className="billing-table">
          <div className="table-head">
            <div className="id">Invoice #</div>
            <div className="plan-type">Plan Type</div>
            <div className="amount">Amount</div>
            <div className="status">Status</div>
            <div className="date">Date</div>
            <div className="view-invoice" />
          </div>
          { BILLS.map(bill => (
            <div className="bill-item" key={bill.invoice_id}>
              <div className="id">{ bill.invoice_id }</div>
              <div className="plan-type">{ bill.plan_type }</div>
              <div className="amount">${ bill.price }</div>
              <div className={classNames("status", bill.status)}>
                { bill.status === 'paid'
                ? <CheckMarkIcon className="check-icon" />
                : <ErrorIcon className="error-icon" />
                }
                { bill.status }
              </div>
              <div className="date">{ bill.date }</div>
              <div className="view-invoice" />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
